import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { URLS } from "../../API/API endpoints";
import Button from "../../components/ui/button";
import axios from "axios";

interface TalkToSalesForm {
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  shopName: string;
  city: string;
}

export const LeadFormComp = ({ formSubmit, utms }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<TalkToSalesForm>({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    shopName: "",
    city: "",
  });
  console.log("utms>>>>>", utms);
  const [formErrors, setFormErrors] = useState<Partial<TalkToSalesForm>>({});
  const validateForm = () => {
    const errors: any = {};

    if (!formData.firstName.trim()) {
      errors.firstName = t("First name is required");
    }

    if (!formData.lastName.trim()) {
      errors.lastName = t("Last name is required");
    }

    const cleanedMobile = formData.mobile
      .replace(/\s+/g, "")
      .replace(/^0+/, ""); // Remove spaces and leading zeros

    if (!cleanedMobile) {
      errors.mobile = t("Mobile number is required");
    } else if (!/^\d{10}$/.test(cleanedMobile)) {
      errors.mobile = t("Please enter a valid 10-digit mobile number");
    }

    if (!formData.email.trim()) {
      errors.email = t("Email address is required");
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = t("Please enter a valid email address");
    }

    if (!formData.shopName.trim()) {
      errors.shopName = t("Shop/Business name is required");
    }

    if (!formData.city.trim()) {
      errors.city = t("City is required");
    }
    console.log("errors", errors);
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    console.log("Onsubmit function");
    e.preventDefault();
    console.log("validateForm", validateForm(), formData);
    if (validateForm()) {
      const payload = {
        name: formData.firstName,
        last_name: formData.lastName,
        phone: formData.mobile.replace(/\s+/g, "").replace(/^0+/, ""),
        email: formData.email,
        city: formData.city,
        shop_name: formData.shopName,
        utm_source: utms?.utm_source,
        utm_medium: utms?.utm_medium,
        utm_campaign: utms?.utm_campaign,
        utm_content: utms?.utm_content,
        utm_term: utms?.utm_term,
        gclid: utms?.gclid,
        fbclid: utms?.fbclid,
        first_landing_page: "",
        last_landing_page: "",
        referrer: "",
      };
      console.log("payload", payload);
      try {
        const response = await axios.post(
          URLS.TALK_TO_SALES, // Replace with actual domain
          payload,
        );

        console.log("Form submitted successfully:", response?.data);
        if (response?.data?.result?.status_code == 200) {
          //   setIsSubmitted(true);

          //To track META users
          if (typeof window !== "undefined" && (window as any).fbq) {
            (window as any).fbq("track", "Lead", {
              content_name: "Cashier Lead Form",
            });
          }

          formSubmit();
        }
        setTimeout(() => {
          //   setIsSubmitted(false);
          // formSubmitDone();
          // Reset form
          setFormData({
            firstName: "",
            lastName: "",
            mobile: "",
            email: "",
            shopName: "",
            city: "",
          });

          setFormErrors({});
        }, 3000);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if ((formErrors as any)[field]) {
      setFormErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  return (
    <div className="w-full">
      <div className="animate-fade-in text-start">
        <form onSubmit={handleFormSubmit} className="space-y-4">
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 ">
            <div>
              <Label htmlFor="firstName">{t("First Name")}</Label>
              <Input
                id="firstName"
                type="text"
                value={formData.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
                aria-invalid={!!formErrors.firstName}
                className={formErrors.firstName && "border-red"}
              />
            </div>

            <div>
              <Label htmlFor="lastName">{t("Last Name")}</Label>
              <Input
                id="lastName"
                type="text"
                value={formData.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
                aria-invalid={!!formErrors.lastName}
                className={formErrors.lastName && "border-red"}
              />
            </div>
          </div>

          <div>
            <Label htmlFor="mobile">{t("Mobile Number")}</Label>
            <Input
              id="mobile"
              type="tel"
              value={formData.mobile}
              onChange={(e) => handleInputChange("mobile", e.target.value)}
              aria-invalid={!!formErrors.mobile}
              aria-describedby="mobile-error"
              className={formErrors.mobile && "border-red"}
            />
          </div>
          <div>
            <Label htmlFor="email">{t("Email Address")}</Label>
            <Input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              aria-invalid={!!formErrors.email}
              aria-describedby="email-error"
              className={formErrors.email && "border-red"}
            />
          </div>
          <div>
            <Label htmlFor="shopName">{t("Shop Name / Business Name")}</Label>
            <Input
              id="shopName"
              type="text"
              value={formData.shopName}
              onChange={(e) => handleInputChange("shopName", e.target.value)}
              aria-invalid={!!formErrors.shopName}
              aria-describedby="shopName-error"
              className={formErrors.shopName && "border-red"}
            />
          </div>
          <div>
            <Label htmlFor="city">{t("City")}</Label>
            <Input
              id="city"
              type="text"
              value={formData.city}
              onChange={(e) => handleInputChange("city", e.target.value)}
              aria-invalid={!!formErrors.city}
              aria-describedby="city-error"
              className={formErrors.city && "border-red"}
            />
          </div>
          <div className="flex justify-end space-x-2">
            <Button
              type="button"
              variant="outline"
              //   onClick={() => setShowModal(false)}
              className="mx-4"
            >
              {t("Cancel")}
            </Button>
            <Button type="submit">{t("Submit")}</Button>
          </div>
        </form>
      </div>
    </div>
  );
};
